export default "__VITE_ASSET__d086d8b7__"